import * as types from '../mutation-types';

const state = {
  currentPage: {
    appliedFilters: 0,
    // New custom assignee types
    bot: 0,
    pending: 0,
    open: 0,
    resolved: 0,
  },
  hasEndReached: {
    appliedFilters: false,
    // New custom assignee types
    bot: false,
    pending: false,
    open: false,
    resolved: false,
  },
};

export const getters = {
  getHasEndReached: $state => filter => {
    return $state.hasEndReached[filter];
  },
  getCurrentPageFilter: $state => filter => {
    return $state.currentPage[filter];
  },
  getCurrentPage: $state => {
    return $state.currentPage;
  },
};

export const actions = {
  setCurrentPage({ commit }, { filter, page }) {
    commit(types.default.SET_CURRENT_PAGE, { filter, page });
  },
  setEndReached({ commit }, { filter }) {
    commit(types.default.SET_CONVERSATION_END_REACHED, { filter });
  },
  reset({ commit }) {
    commit(types.default.CLEAR_CONVERSATION_PAGE);
  },
};

export const mutations = {
  [types.default.SET_CURRENT_PAGE]: ($state, { filter, page }) => {
    $state.currentPage = {
      ...$state.currentPage,
      [filter]: page,
    };
  },
  [types.default.SET_CONVERSATION_END_REACHED]: ($state, { filter }) => {
    $state.hasEndReached = {
      ...$state.hasEndReached,
      [filter]: true,
    };
  },
  [types.default.CLEAR_CONVERSATION_PAGE]: $state => {
    $state.currentPage = {
      appliedFilters: 0,
      // New custom assignee types
      bot: 0,
      pending: 0,
      open: 0,
      resolved: 0,
    };

    $state.hasEndReached = {
      appliedFilters: false,
      // New custom assignee types
      bot: false,
      pending: false,
      open: false,
      resolved: false,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
